import { IFilterMultiSelectOption } from 'transfix-ui'

export const getMultiStopSelectedValues = (selected: IFilterMultiSelectOption[]) => {
  // if isMultiStop and !isMultiStop are both selected, its functionally the same
  // as if neither is selected
  let isMultiStop: boolean | undefined
  const notMultiStopChecked = selected.find(option => option.value === 'false')?.selected
  const isMultiStopChecked = selected.find(option => option.value === 'true')?.selected

  if (
    !(notMultiStopChecked && isMultiStopChecked) &&
    !(!notMultiStopChecked && !isMultiStopChecked)
  ) {
    isMultiStop = isMultiStopChecked
  }
  return isMultiStop
}
